import styled from "styled-components";

export const StyledHeader = styled.header`
  background-color: #8dabe2;
  padding:20px;
  @media (max-width: 600px) {
    padding:0px;
  };
`;

export const Logo = styled.div`
  flex: 1;
  font-size: 18px;

  span {
    font-size: 30px;
  }
  @media (max-width: 600px) {
    flex: initial;
  };
`;

export const Nav = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 15px;
  color: #ffffff;
  @media (max-width: 600px) {
    margin-bottom:0px;
    justify-content: space-around;
  };
`;

export const Phrase = styled.div`
  flex: 4;
  font-family: "Ephesis", cursive;
  font-size:2rem;
  text-align: center;
  @media (max-width: 600px) {
    display:none;
  };
`;

export const NavRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 600px) {
    flex: initial;
  };
`;

export const LocationPathItem = styled.span`
  &:hover{
    text-decoration: underline;
    cursor:pointer;
  }
`;
